//imgs
import img01 from "../../assets/images/chapters/03/01.jpg";
import img02 from "../../assets/images/chapters/03/02.jpg";
import img03 from "../../assets/images/chapters/03/03.jpg";
import img04 from "../../assets/images/chapters/03/04.jpg";
import img05 from "../../assets/images/chapters/03/05.jpg";
import img06 from "../../assets/images/chapters/03/06.jpg";

import img14 from "../../assets/images/chapters/03/14.jpg";
import img15 from "../../assets/images/chapters/03/15.jpg";
import img16 from "../../assets/images/chapters/03/16.jpg";
import img17 from "../../assets/images/chapters/03/17.jpg";

import img18 from "../../assets/images/chapters/03/18.jpg";

import { captions, list, gifs } from "../../assets/data/chapters/chapter03";

// pictureReveal
import ScrollReveal from "../scrollReveal";

const Chapter = () => {
  return (
    <div id="chapter03">
      <div className="group01">
        <div className="row">
          <ScrollReveal className="title">
            <span>
              Manned{"\n"}spacecraft{"\n"}
              center{"\n"}
              houston,{"\n"}
              texas.
            </span>
          </ScrollReveal>

          <ScrollReveal className="picture">
            <img src={img01} alt="" />
            <p className="caption">{captions[0]}</p>
          </ScrollReveal>
        </div>
      </div>

      <div className="group02">
        <div className="row">
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img02} alt="" />
              <p className="caption">{captions[1]}</p>
            </ScrollReveal>
          </div>
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img03} alt="" />
            </ScrollReveal>

            <ScrollReveal className="picture">
              <img src={img04} alt="" />
            </ScrollReveal>
          </div>

          <div className="column">
            <ScrollReveal className="picture">
              <img src={img05} alt="" />
            </ScrollReveal>
            <ScrollReveal className="picture">
              <img src={img06} alt="" />
            </ScrollReveal>
          </div>
        </div>
      </div>

      <div className="group03">
        {list.map((elem) => (
          <ScrollReveal className="picture">
            <img src={elem.img} alt="" />
            {elem.caption && <p className="caption">{elem.caption}</p>}
          </ScrollReveal>
        ))}
      </div>

      <div className="group04">
        <div className="row">
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img14} alt="" />
            </ScrollReveal>
            <ScrollReveal className="picture">
              <img src={img15} alt="" />
            </ScrollReveal>
            <ScrollReveal className="picture">
              <img src={img16} alt="" />
              <p className="caption">{captions[5]}</p>
            </ScrollReveal>
          </div>
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img17} alt="" />
              <p className="caption">{captions[6]}</p>
            </ScrollReveal>
          </div>
        </div>
      </div>

      <div className="group05">
        {gifs.map((elem) => (
          <ScrollReveal className="picture">
            <img src={elem} alt="" />
          </ScrollReveal>
        ))}
      </div>

      <div className="group06">
        <ScrollReveal className="title">
          <span>
            Interim{"\n"}
            storage{"\n"}
            assembly{"\n"}
          </span>
        </ScrollReveal>

        <ScrollReveal className="title">
          <span>
            environmental{"\n"}
            control{"\n"}
            system{"\n"}
          </span>
        </ScrollReveal>

        <ScrollReveal className="picture">
          <img src={img18} alt="" />
        </ScrollReveal>
      </div>
    </div>
  );
};

export default Chapter;
